
import exclamationMarkTriangleFill from "../icons/exclamation-mark-triangle-fill.png"
import checkmarkCircleFill from "../icons/checkmark-circle-fill.png"
import cart from "../icons/cart.png"
import trash from '../icons/trash.png'
import chevron from '../icons/chevron.png'
import refresh from '../icons/refresh.png'

import car from '../icons/car-circle.png'
import card from '../icons/card-circle.png'
import arrowLeft from '../icons/arrow-left-circle.png'
import eject from '../icons/eject-circle.png'
import magnifyingGlassCircle from '../icons/magnifying-glass-circle.png'
import receiptArrow from '../icons/arrowshape.turn.up.right.png'

export default {

  exclamationMarkTriangleFill,
  checkmarkCircleFill,
  cart,
  trash,
  chevron,
  refresh,

  car,
  card,
  arrowLeft,
  eject,
  magnifyingGlassCircle,
  receiptArrow
};
